import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {

  private messageSource = new BehaviorSubject('default message');

  private dataStringSource = new BehaviorSubject('');

  dataString = this.dataStringSource.asObservable();


  private menuList: any = []
  currentMessage = this.messageSource.asObservable();

  private popupState = new BehaviorSubject<boolean>(false);

  popupState$ = this.popupState.asObservable();

 

  constructor() { }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  insertData(data: string) {
    this.dataStringSource.next(data)
  }

  open(value:boolean) {
    this.popupState.next(value);
  }

}


// WEBPACK FOOTER //
// /codebuild/output/src1351935441/src/src/app/shared/services/data-sharing/data.service.ts